export default {
    text: 'Êtes-vous sûr(e) de vouloir supprimer le réseau {{0}} ?',
    buttons: {
        confirm: 'Oui, supprimer',
        cancel: 'Annuler',
    },
};
